webpackJsonp([25],{

/***/ 1045:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cinemaListing_vue__ = __webpack_require__(1098);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f86a2e98_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cinemaListing_vue__ = __webpack_require__(1156);
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cinemaListing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f86a2e98_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cinemaListing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1098:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_partials_QuickBook_vue__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_internet_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_partials_mainBanner__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_slick__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_partials_advertise_vue__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helper_constant_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helper_constant_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__helper_constant_js__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    QuickBook: __WEBPACK_IMPORTED_MODULE_2__components_partials_QuickBook_vue__["a" /* default */],
    landingBanner: __WEBPACK_IMPORTED_MODULE_4__components_partials_mainBanner__["a" /* default */],
    Advertise: __WEBPACK_IMPORTED_MODULE_7__components_partials_advertise_vue__["a" /* default */],
    Slick: __WEBPACK_IMPORTED_MODULE_5_vue_slick__["default"]
  },
  metaInfo: __WEBPACK_IMPORTED_MODULE_8__helper_constant_js__["metaInfo"],
  data: function data() {
    return {
      project: __WEBPACK_IMPORTED_MODULE_8__helper_constant_js__["PROJECT"],
      metaWebsite: __WEBPACK_IMPORTED_MODULE_8__helper_constant_js__["METAWEBSITE"],
      metaOrganization: __WEBPACK_IMPORTED_MODULE_8__helper_constant_js__["METAORGANIZATION"],
      filterModal: false,
      cinemaName: "star",
      cinemaName1: "akil",
      cinemaName2: "oscar",
      cinemaSlider: {
        arrows: true,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: "8%",
        slidesToScroll: 1,
        responsive: [{
          breakpoint: 992,
          settings: {
            dots: true,
            arrows: false,
            centerPadding: "0%",
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
      },
      landingBanner: {
        initialSlide: 0,
        dots: true,
        arrows: true,
        autoplay: true,
        loop: true,
        infinite: true,
        slidesToShow: 1,
        centerMode: true,
        slidesToScroll: 1,
        autoplaySpeed: 3500,
        centerPadding: "5%",
        responsive: [{
          breakpoint: 992,
          settings: {
            arrows: false,
            centerMode: false
          }
        }]
      },
      filters: [],
      selectedFilter: {},
      dropDowns: {
        locations: {
          selected: {
            Title: "All Locations"
          },
          list: []
        }
      },
      OrganizationList: [],
      cinemasList: [],
      cinemasListCopy: [],
      cinemaFilterList: [],
      selectedOrg: "All Cinemas",
      filtersChips: []
    };
  },
  mounted: function mounted() {},
  beforeMount: function beforeMount() {
    this.GetAllShows();
    this.getAllFilters();
    // this.fetchCinemasList();
  },

  methods: {
    onToggle: function onToggle(index) {
      this.$root.$emit("bv::toggle::collapse", index);
    },
    onClearAllFilters: function onClearAllFilters() {
      this.filtersChips = [];
      this.selectedFilter = {};
      this.GetAllShows();
    },
    onRemoveFilterChips: function onRemoveFilterChips(filter_key, value, index) {
      this.filtersChips.splice(index, 1);
      var _index = this.selectedFilter[filter_key].indexOf(value);

      if (_index > -1) {
        this.selectedFilter[filter_key].splice(_index, 1);
      }
      this.GetAllShows();
    },

    onClickFilter: function onClickFilter(filter_key, value, index, title) {
      var __index = this.filtersChips.findIndex(function (x) {
        return x.title === title;
      });

      if (__index > -1) {
        this.filtersChips.splice(__index, 1);
      } else {
        this.filtersChips.push({
          title: title,
          filter_key: filter_key,
          value: value
        });
      }
      var obj = {};
      obj[filter_key] = [];

      this.selectedFilter = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, obj, this.selectedFilter);
      var _index = this.selectedFilter[filter_key].indexOf(value);
      if (_index > -1) {
        this.selectedFilter[filter_key].splice(_index, 1);
      } else {
        this.selectedFilter[filter_key].push(value);
      }
      this.GetAllShows();
    },
    filterData: function filterData(data, filter) {
      if (filter == "location") {
        this.dropDowns.locations.selected = data;
      }
      this.GetAllShows();
    },
    onClickCinemaNameAll: function onClickCinemaNameAll() {
      this.cinemasList = this.cinemasListCopy;
      this.selectedOrg = "All Cinemas";
    },

    onClickCinemaName: function onClickCinemaName(params) {
      this.selectedOrg = params.organizationName;
      this.cinemasList = this.cinemasListCopy.filter(function (x) {
        if (x.organizationID == params.organizationID) {
          return x;
        }
      });
      var elmnt = document.getElementById("cinemas-listing");
      elmnt.scrollIntoView();
      // cinemas-listing
    },
    GetAllShows: function GetAllShows() {
      var _this = this;

      this.showLoading();
      var payload = {};
      if (this.dropDowns.locations.selected.Title != "All Locations") {
        payload.LocationID = this.dropDowns.locations.selected.LocationID;
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selectedFilter).map(function (x) {
        if (_this.selectedFilter[x].length > 0) {
          payload[x] = _this.selectedFilter[x].toString();
        }
      });
      Object(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__["makeRequest"])("/GetAllShow", "POST", null, payload).then(function (result) {
        _this.hideLoading();
        _this.OrganizationList = result.res.data.Cinemas;
        _this.OrganizationList = Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["uniqBy"])(_this.OrganizationList, "organizationID");
        _this.cinemasList = [];
        _this.cinemasList = result.res.data.Cinemas;
        _this.cinemaFilterList = result.res.data.Cinemas;
        _this.cinemasListCopy = result.res.data.Cinemas;
        _this.$refs.cinemaSlick.destroy();
        _this.$nextTick(function () {
          _this.$refs.cinemaSlick.create();
          _this.$refs.cinemaSlick.goTo(1, true);
        });
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    getAllFilters: function getAllFilters() {
      var _this2 = this;

      var payload = {
        FilterType: "Cinema"
      };
      Object(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__["makeRequest"])("/GetAllFilter", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        if (!error) {
          _this2.filters = [];
          res.data.Filters.map(function (x, index) {
            _this2.filters.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, x, {
              collapseId: "collapse-" + (index + 1)
            }));
          });
          _this2.dropDowns.locations.list = res.data.List.Locations;
          _this2.dropDowns.locations.list.push({
            Title: "All Locations"
          });
        } else {
          console.log("Response Error ");
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    fetchCinemasList: function fetchCinemasList() {
      var _this3 = this;

      Object(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__["makeRequest"])("/GetAllCinemasList", "POST", null, null).then(function (result) {
        _this3.cinemasList = result.res.data.Data;
        _this3.cinemaFilterList = result.res.data.Data;
        _this3.cinemasListCopy = result.res.data.Data;
        _this3.$refs.cinemaSlick.destroy();
        _this3.$nextTick(function () {
          _this3.$refs.cinemaSlick.create();
          _this3.$refs.cinemaSlick.goTo(1, true);
        });
      }).catch(function (error) {
        console.log("Error", error);
      });
    }
  }
});

/***/ }),

/***/ 1156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.project == 'ticketak')?_c('script',{attrs:{"type":"application/ld+json"},domProps:{"innerHTML":_vm._s(_vm.metaWebsite)}}):_vm._e(),_vm._v(" "),(_vm.project == 'ticketak')?_c('script',{attrs:{"type":"application/ld+json"},domProps:{"innerHTML":_vm._s(_vm.metaOrganization)}}):_vm._e(),_vm._v(" "),_c('section',{staticClass:"section-banner"},[_c('Slick',{ref:"cinemaSlick",attrs:{"options":_vm.landingBanner}},_vm._l((_vm.OrganizationList),function(org,orgKey){return _c('div',{key:orgKey},[_c('div',{staticClass:"cinema-bannerContainer",on:{"click":function($event){return _vm.onClickCinemaName(org)}}},[(org.organization_card_img.includes('assets'))?_c('img',{staticClass:"img-fluid",attrs:{"src":org.organization_card_img,"alt":""}}):(_vm.project == 'ticketak')?_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(555),"alt":""}}):_c('img',{staticClass:"img-fluid dummy_back",attrs:{"src":__webpack_require__(1157),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"bannerContent"},[_c('div',{staticClass:"w-75 pr-2"},[_c('div',{staticClass:"details"})]),_vm._v(" "),_c('div',{staticClass:"w-25"})])])])}),0)],1),_vm._v(" "),_c('div',{staticClass:"wrapper pt-0",attrs:{"id":"cinemas-listing"}},[_c('div',{staticClass:"border-bottom pb-1 my-4"},[_c('div',{staticClass:"section-title fs-25",staticStyle:{"color":"black"}},[_vm._v("\n        "+_vm._s(_vm.$t("CINEMAS"))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[(false)?_c('div',{staticClass:"col-md-3 col-lg-3 col-xl-2 d-none d-md-block"},[_vm._l((_vm.filters),function(filter,filterKey){return _c('div',{key:filterKey,staticClass:"accordian-container"},[_c('button',{staticClass:"btn-accordian no-focus",class:_vm.selectedFilter &&
              _vm.selectedFilter[filter.filter_key] &&
              _vm.selectedFilter[filter.filter_key].length > 0
                ? 'active'
                : '',on:{"click":function($event){return _vm.onToggle(filter.collapseId)}}},[_c('img',{attrs:{"src":filter.icon,"height":"15px","width":"15px"}}),_vm._v("\n            "+_vm._s(filter.filter_name)+"\n          ")]),_vm._v(" "),_c('b-collapse',{staticClass:"accordian-container",attrs:{"accordion":"my-accordion","role":"tabpanel","id":filter.collapseId}},_vm._l((filter.all_filter),function(filterList,filterListKey){return _c('div',{key:filterListKey,staticClass:"btn-accordian-child d-flex align-items-center"},[_c('input',{attrs:{"id":filter.filter_key + filterListKey,"name":filter.filter_key + filterListKey,"type":"checkbox"},domProps:{"checked":_vm.selectedFilter[filter.filter_key] &&
                  filterList.value ==
                    _vm.selectedFilter[filter.filter_key][filterKey]
                    ? true
                    : false},on:{"click":function($event){return _vm.onClickFilter(
                    filter.filter_key,
                    filterList.value,
                    filterListKey,
                    filterList.title
                  )}}}),_vm._v(" "),_c('label',{staticClass:"mb-0",attrs:{"for":filter.filter_key + filterListKey}},[_vm._v(_vm._s(filterList.title))])])}),0)],1)}),_vm._v(" "),_c('Advertise')],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-lg-3 col-xl-2 d-none"},[_c('div',{staticClass:"filter-sticky"},[_c('div',{staticClass:"accordian-container"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.cinemas",modifiers:{"cinemas":true}}],staticClass:"btn-accordian"},[_c('img',{attrs:{"src":__webpack_require__(556),"height":"auto","width":"20px","alt":"Cinema-icon"}}),_vm._v("\n              "+_vm._s(_vm.selectedOrg)+"\n            ")]),_vm._v(" "),_c('b-collapse',{staticClass:"btn-accordian-content",attrs:{"id":"cinemas"}},[_c('button',{staticClass:"btn-accordian-child",on:{"click":function($event){return _vm.onClickCinemaNameAll()}}},[_vm._v("\n                "+_vm._s(_vm.$t("ALL_CINEMAS"))+"\n              ")]),_vm._v(" "),_vm._l((_vm.OrganizationList),function(organization,organizationKey){return _c('button',{key:organizationKey,staticClass:"btn-accordian-child",on:{"click":function($event){return _vm.onClickCinemaName(organization)}}},[_vm._v("\n                "+_vm._s(organization.organizationName)+"\n              ")])})],2)],1),_vm._v(" "),_c('div',{staticClass:"accordian-container"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.locations",modifiers:{"locations":true}}],staticClass:"btn-accordian"},[_c('img',{attrs:{"src":__webpack_require__(550),"height":"18px","width":"18px","alt":""}}),_vm._v("\n              "+_vm._s(_vm.dropDowns.locations.selected.Title)+"\n            ")]),_vm._v(" "),_c('b-collapse',{staticClass:"btn-accordian-content",attrs:{"id":"locations"}},_vm._l((_vm.dropDowns.locations
                  .list),function(location,locationListIndex){return _c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.locations",modifiers:{"locations":true}}],key:locationListIndex,staticClass:"btn-accordian-child",on:{"click":function($event){return _vm.filterData(location, 'location')}}},[_vm._v("\n                "+_vm._s(location.Title)+"\n              ")])}),0)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-9 col-lg-9 col-xl-10"},[_c('div',[_c('ul',{staticClass:"list-inline"},[_vm._l((_vm.filtersChips),function(filter,filterKey){return _c('li',{key:filterKey,staticClass:"list-inline-item"},[_c('div',{staticClass:"badge badge-pill bg-pink text-white"},[_vm._v("\n                "+_vm._s(filter.title)+"\n                "),_c('button',{staticClass:"btn-badge-close",on:{"click":function($event){return _vm.onRemoveFilterChips(
                      filter.filter_key,
                      filter.value,
                      filterKey
                    )}}},[_vm._v("\n                  x\n                ")])])])}),_vm._v(" "),(_vm.filtersChips.length > 0)?_c('li',{staticClass:"list-inline-item"},[_c('div',{staticClass:"badge badge-pill bg-pink text-white"},[_vm._v("\n                Clear All\n                "),_c('button',{staticClass:"btn-badge-close",on:{"click":function($event){return _vm.onClearAllFilters()}}},[_vm._v("\n                  x\n                ")])])]):_vm._e()],2)]),_vm._v(" "),(_vm.cinemasList.length > 0)?_c('div',{staticClass:"row cinema-listing"},_vm._l((_vm.cinemasList),function(cinemaItem,cinemaListingKey){return _c('div',{key:cinemaListingKey,staticClass:"col-6 col-sm-6 col-md-6 col-lg-4 col-xl-2 mb-2"},[_c('router-link',{attrs:{"to":{ name: 'cinema', params: { cinemaId: cinemaItem['id'] } }}},[_c('div',{staticClass:"cinema-card"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(cinemaItem.cinema_card_img),expression:"cinemaItem.cinema_card_img"}],staticClass:"movie-poster"}),_vm._v(" "),_c('div',{staticClass:"cinema-content"},[_c('div',{staticClass:"cinema-name"},[_vm._v(_vm._s(cinemaItem.title))]),_vm._v(" "),_c('p',{staticClass:"cinema-desc"},[_vm._v(_vm._s(cinemaItem.desc))])])])])],1)}),0):(_vm.cinemasList.length == 0 && !_vm.data_loading)?_c('div',[_vm._v("\n          "+_vm._s(_vm.$t("NO_CINEMAS_FOUND"))+"\n        ")]):_vm._e()])])]),_vm._v(" "),(_vm.filterModal)?_c('section',{staticClass:"filter-modal"},[_c('div',{staticClass:"filter-modalContent"},[_c('nav',[_c('img',{attrs:{"src":__webpack_require__(293),"height":"20px","width":"20px","alt":"Back"},on:{"click":function($event){_vm.filterModal = !_vm.filterModal}}}),_vm._v(" "),_c('h6',[_vm._v("Filter")]),_vm._v(" "),_c('a',{staticClass:"btn-reset"},[_vm._v("RESET")])]),_vm._v(" "),_c('div',{staticClass:"text-muted mb-3"},[_vm._v("S0RT BY")]),_vm._v(" "),_c('div',[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.today",modifiers:{"today":true}}],staticClass:"btn-filterCollapse no-focus"},[_c('img',{attrs:{"src":__webpack_require__(182),"height":"15px","width":"15px"}}),_vm._v("\n          Today, FRI 15\n        ")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"today"}},[_c('ul',{staticClass:"filter-list"},_vm._l((5),function(filterList,filterListKey){return _c('li',{key:filterListKey},[_c('label',{attrs:{"for":"date"}},[_vm._v("Movie Date")]),_vm._v(" "),_c('input',{attrs:{"id":"date","type":"checkbox"}})])}),0)])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.locationFilter",modifiers:{"locationFilter":true}}],staticClass:"btn-filterCollapse no-focus"},[_c('img',{attrs:{"src":__webpack_require__(182),"height":"15px","width":"15px"}}),_vm._v("\n          Location\n        ")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"locationFilter"}},[_c('p',[_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquam\n            eius hic facilis, suscipit in magnam ratione? Rem neque debitis\n            dolore id. Voluptatem qui non delectus, rerum eaque doloremque\n            quibusdam veniam.\n          ")])])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.cinemaFilter",modifiers:{"cinemaFilter":true}}],staticClass:"btn-filterCollapse no-focus"},[_c('img',{attrs:{"src":__webpack_require__(182),"height":"15px","width":"15px"}}),_vm._v("\n          Cinema\n        ")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"cinemaFilter"}},[_c('ul',{staticClass:"filter-list"},_vm._l((5),function(filterList,filterListKey){return _c('li',{key:filterListKey},[_c('label',{attrs:{"for":"cinema"}},[_vm._v("Cinema")]),_vm._v(" "),_c('input',{attrs:{"id":"cinema","type":"checkbox"}})])}),0)])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.languageFilter",modifiers:{"languageFilter":true}}],staticClass:"btn-filterCollapse no-focus"},[_vm._v("\n          Language\n        ")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"languageFilter"}},[_c('ul',{staticClass:"filter-list"},_vm._l((5),function(filterList,filterListKey){return _c('li',{key:filterListKey},[_c('label',{attrs:{"for":"lang"}},[_vm._v("English")]),_vm._v(" "),_c('input',{attrs:{"id":"lang","type":"checkbox"}})])}),0)])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"mb-5"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.typeFilter",modifiers:{"typeFilter":true}}],staticClass:"btn-filterCollapse no-focus"},[_vm._v("\n          Type\n        ")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"typeFilter"}},[_c('ul',{staticClass:"filter-list"},_vm._l((5),function(filterList,filterListKey){return _c('li',{key:filterListKey},[_c('label',{attrs:{"for":"type"}},[_vm._v("Movie Type")]),_vm._v(" "),_c('input',{attrs:{"id":"type","type":"checkbox"}})])}),0)])],1),_vm._v(" "),_vm._m(0)])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-container"},[_c('button',{staticClass:"btn-applyFilter no-focus"},[_vm._v("APPLY FILTER")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1157:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Wanasa_Dummy.3fea980.png";

/***/ })

});


// WEBPACK FOOTER //
// static/js/25.68dcf67bb79cc13521bf.js